import type React from "react";
import { Toaster as ShadcnToaster } from "src/shadcn/components/sonner";

const Toaster = (props: React.ComponentProps<typeof ShadcnToaster>) => (
  <ShadcnToaster
    toastOptions={{
      classNames: {
        toast: "cn-toast neeto-ui-toastr",
        success:
          "!bg-success-solid !text-success-solid-foreground !border-success-solid/30",
        error:
          "!bg-error-solid !text-error-solid-foreground !border-error-solid/30",
        warning:
          "!bg-warning-solid !text-warning-solid-foreground !border-warning-solid/30",
        info: "!bg-info-solid !text-info-solid-foreground !border-info-solid/30",
      },
    }}
    {...props}
  />
);

export { Toaster };
